export default function(vnode, meta) {
  if (process.env.NODE_ENV !== 'production')
    console.warn('v-fragment SSR is not implemented yet.')
}